import { defineStore } from "pinia";
import { ref } from "vue";
import pipingApi from "../api";
import { useResponseSet } from "../store/response-set";
// Store
const errorHandler = (err) => {
    window?.serverState?.retrieveState;
    console.error(err);
};
export function createPipingStore(pipedResponseDef) {
    return defineStore(`pipingStore-${pipedResponseDef.studyId}-${pipedResponseDef.activityId ?? 0}-${pipedResponseDef.taskId ?? 0}`, () => {
        const config = ref();
        const responseSetStore = useResponseSet();
        responseSetStore.load();
        const activityId = ref(pipedResponseDef.activityId);
        const taskId = ref(pipedResponseDef.taskId);
        const dependents = ref(undefined);
        const pipedResponseDefMap = new Map();
        const getConfig = async () => {
            try {
                config.value = await pipingApi.getConfig(pipedResponseDef.studyId);
            }
            catch (err) {
                errorHandler(err);
            }
        };
        if (pipedResponseDef.studyId > 0) {
            getConfig();
        }
        else {
            config.value = { activities: [] };
        }
        const getTaskDependents = async () => {
            if (!dependents.value && activityId.value) {
                dependents.value = (await pipingApi.getTaskDependents(pipedResponseDef.studyId, activityId.value, taskId.value ?? -1)).dependents;
            }
        };
        getTaskDependents();
        const getPipedValue = async (pipeId, userId) => {
            await responseSetStore.reload();
            return (responseSetStore.responseSet[pipeId] ??
                (await pipingApi.getResponse(pipedResponseDef.studyId, pipeId, userId)));
        };
        const save = async (value, pipedResponseProp) => {
            const pipedResponseDef = {
                id: -1,
                studyId: -1,
                activityId: -1,
                taskId: -1,
                requiredActivityId: -1,
                requiredTaskId: -1,
                requiredResponseType: -1
            };
            Object.assign(pipedResponseDef, pipedResponseProp);
            if (value.response && value.task) {
                pipedResponseDef.requiredActivityId = Number(value.task.id);
                pipedResponseDef.requiredTaskId = Number(value.task.subChoice?.id);
                pipedResponseDef.requiredTaskSubOption = Number(value.task.subChoice?.subChoice?.id);
                pipedResponseDef.requiredResponseType = Number(value.response?.id);
                pipedResponseDef.requiredResponseSubOption = Number(value.response?.subChoice?.id);
            }
            const res = await pipingApi.save(pipedResponseDef);
            pipedResponseDefMap.set(res.id, res);
            return res;
        };
        const getPipedResponseDef = async (pipeId) => {
            if (!pipedResponseDefMap.has(pipeId)) {
                pipedResponseDefMap.set(pipeId, await fetchPipedResponseDef(pipeId));
            }
            return pipedResponseDefMap.get(pipeId);
        };
        const fetchPipedResponseDef = async (pipeId) => {
            const res = await pipingApi.getPipedResponseDef(pipedResponseDef.studyId, pipeId);
            return res;
        };
        const setFocus = (aid, tid) => {
            activityId.value = aid;
            if (tid)
                taskId.value = tid;
        };
        return { config, setFocus, save, getPipedResponseDef, getPipedValue, dependents };
    })();
}
